import React from 'react';
import { createSelector } from 'reselect';
import { find, get } from 'lodash-es';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { collectionSelector, channelsSelector } from 'common/selectors';
import { navigationItemModel } from 'common/api/models/index';

import { Link, withRouter } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleLeft } from '@fortawesome/pro-regular-svg-icons';

const MobileBreadcrumbs = () => {
  const breadcrumbs = useSelector(breadcrumbsSelector);
  const { t } = useTranslation();

  return (
    breadcrumbs && (
      <nav aria-label={t('breadcrumbs_navigation.aria_label')} className="ct-breadcrumb-mobile" data-e2e="breadcrumb">
        <ol>
          {get(breadcrumbs, 'parent.parentId') ? (
            <li>
              <Link
                to={get(breadcrumbs, 'parent.url')}
                data-e2e="breadcrumb-prev"
                className="ct-breadcrumb-mobile__prev"
              >
                <FontAwesomeIcon icon={faAngleLeft} />
                {get(breadcrumbs, 'parent.title')}
              </Link>
            </li>
          ) : (
            <li>
              <Link to="/" className="ct-breadcrumb-mobile__prev" data-e2e="breadcrumb-prev">
                <FontAwesomeIcon icon={faAngleLeft} />
                {get(breadcrumbs, 'parent.title')}
              </Link>
            </li>
          )}
          <li className="ct-breadcrumb-mobile__current-wrapper">
            <div aria-current="page" className="ct-breadcrumb-mobile__current">
              {get(breadcrumbs, 'current.title')}
            </div>
          </li>
        </ol>
      </nav>
    )
  );
};

const getItemById = (collection, itemId) => (!isNaN(itemId) ? find(collection, ({ id }) => id === itemId) : null);

const breadcrumbsSelector = createSelector(collectionSelector, channelsSelector, (collection, channels) => {
  const navigationItems = channels.map(navigationItemModel);
  const currentChannel = getItemById(navigationItems, collection.channelId);
  const currentChannelId = get(currentChannel, 'id');

  if (isNaN(currentChannelId) || currentChannelId === -1) {
    return null;
  }

  return {
    parent: find(navigationItems, ({ id }) => id === get(currentChannel, 'parentId')),
    current: currentChannel,
  };
});

export const MobileBreadcrumbsDecorated = withRouter(MobileBreadcrumbs);
